import {Link} from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import {useracc, postApi, getCookie, setCookie} from '../utils/functions';

import Products from './services/products';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { BsFillPatchCheckFill, BsCheck2, BsFillLightningChargeFill } from "react-icons/bs";
import { FaCheckCircle, FaMoneyBillWave } from "react-icons/fa";

export default function HomePage(services) {
  
  const [restream, setRestream] = useState([]);
  const [period, setPeriod] = useState(1);
  
  useEffect(() => {
    async function loadServices() {
      let params = new URLSearchParams();
      params.append('product', 'restream');
      const x = await postApi(`/v3/frontend/index`, params);
      setRestream(x.data);
    }
    loadServices();
    window.scrollTo(0, 0);
  }, []);

  async function addToCart(product, period) {
    await setCookie('order', [{product, period}]);
    window.location.href = `https://portal.ultrastream.io/cart`;
  }


  return (
    <main className="main">
      
      <section id="hero" className="hero section dark-background">

        <div className="hero-background">
          <img src="/images/bg-14.webp" alt="" data-aos-duration="1000" />
          <div className="overlay"></div>
        </div>

        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="hero-content">
                {/*<span className="hero-badge">Innovative Solutions</span>*/}
                <h1>Stream to many destinations</h1>
                <p>We offer a comprehensive solution from restreaming services to advanced visual radio station services.</p>
                <div className="hero-actions">
                  <Link to={'/restream'} className="btn-primary">Restream</Link>
                  <Link to={'/radio'} className="btn-primary">Radio</Link>
                </div>
                <div className="hero-stats">
                  <div className="stat-item">
                    <span className="stat-number">500+</span>
                    <span className="stat-label">Streams Delivered</span>
                  </div>
                  {/*<div className="stat-item">
                    <span className="stat-number">98%</span>
                    <span className="stat-label">Client Satisfaction</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">24/7</span>
                    <span className="stat-label">Support Available</span>
                  </div>*/}
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="hero-visual">
                <div className="row g-3">
                  <div className="col-6">
                    <div className="feature-card">
                      <i className="bi bi-shield-check"></i>
                      <span>Secure &amp; Reliable</span>
                    </div>
                    <div className="feature-card">
                      <i className="bi bi-people"></i>
                      <span>Expert Team</span>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="feature-card">
                      <i className="bi bi-speedometer2"></i>
                      <span>High Performance</span>
                    </div>
                    <div className="feature-card">
                      <i className="bi bi-award"></i>
                      <span>Award Winning</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="featured-services" className="featured-services section light-background">

        
        <div className="container section-title">
          <h2>MultiStreaming</h2>
        </div>

        <div className="container">

          <div className="row">
            <div className="col-lg-6">
              <div className="services-content" data-aos-duration="900">
                <span className="subtitle">Restreaming</span>
                <h2>Grow your audience across multiple demographics without extra "live" time.</h2>
                <p data-aos-duration="800">Maximized Audience Reach: You can broadcast to multiple demographics simultaneously—such as professional audiences on Youtube, high-energy viewers on TikTok, and gaming communities on Twitch.</p>
                <div className="mt-4" data-aos-duration="1100">
                  <Link to={'/restream'} className="btn-consultation"><span>View More</span><i className="bi bi-arrow-right"></i></Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="services-image">
                <img src="/images/services-9.webp" alt="Business Services" className="img-fluid" />
                <div className="shape-circle"></div>
                <div className="shape-accent"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="pricing" className="pricing section">
        <div className="container section-title">
          <h2>Pricing</h2>
          <div className="features">
            <div className="tab-content">
              <div className="content-box">
                <div className="highlight d-flex align-items-center justify-content-center">
                  <span>Save 10% on annual pricing.</span>
                  <span className="mx-2 btn-border">
                    <span className={period===1?'btn-custom-selected':'btn-custom'} onClick={()=>setPeriod(1)}>Month</span>
                  </span>
                  <span className="btn-border">
                    <span className={period===12?'btn-custom-selected':'btn-custom'} onClick={()=>setPeriod(12)}>Year</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row gy-4 justify-content-center">
            <Products products={restream} period={period} />
          </div>
        </div>
      </section>

      <section id="call-to-action" className="call-to-action section light-background">
        <div className="container">
          <div className="cta-wrapper">
            <div className="cta-shapes">
              <div className="shape shape-1"></div>
              <div className="shape shape-2"></div>
              <div className="shape shape-3"></div>
            </div>
            <div className="row g-0">
              <div className="col-lg-7">
                <div className="cta-content p-5">
                  <span className="badge-custom">Multistreaming</span>
                  <h2 className="mt-4 mb-4">Works with most streaming apps</h2>
                  <p className="mb-4">There is no need to make changes to your existing setup. Most integrations are seamless and simple..</p>
                  <div className="row benefits-row mb-5">
                    <div className="col-md-6">
                      <div className="benefit-item">
                        <div className="icon-box">
                          <BsFillLightningChargeFill />
                        </div>
                        <div className="benefit-content">
                          <h5>Quick Setup</h5>
                          <p>Simplified configuration processes across all platforms</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="benefit-item">
                        <div className="icon-box">
                          <FaMoneyBillWave />
                        </div>
                        <div className="benefit-content">
                          <h5>Annual Pricing</h5>
                          <p>Save up to 10% on annual pricing</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="action-buttons d-flex">
                    <div><Link to={'/cart'} className="btn btn-primary">Order Now</Link></div>
                    <div><Link to={'/restream'} className="btn btn-outline">Learn More</Link></div>
                    <div className="guarantee-badge">
                      <BsFillPatchCheckFill size={24} color={'#12a16b'} />
                      <span>30-Day Money Back</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="cta-image-container">
                  <img src="/images/illustration-3.webp" alt="Illustration" className="img-fluid main-image" />
                  {/*<div className="floating-element element-1">
                    <i className="bi bi-star-fill"></i>
                    <span>4.9 Rating</span>
                  </div>
                  <div className="floating-element element-2">
                    <i className="bi bi-people-fill"></i>
                    <span>10k+ Users</span>
                  </div>
                  <div className="pattern-dots"></div>*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
